import { NavLink } from 'react-router-dom';
import { useQuery } from 'urql';
import PageHeader from '@/components/Layout/PageHeader.jsx';
import { SECURITY_ROLES_QUERY } from '@/pages/Seguridad/RolesPermisos/gql.js';
import { SECURITY_USERS_QUERY } from '@/pages/Seguridad/Usuarios/gql.js';

const quickLinks = [
  { title: 'Usuarios', description: 'ABM completo, roles múltiples, grants, denies y sucursales habilitadas.', path: '/seguridad/usuarios' },
  { title: 'Roles', description: 'Matriz de permisos por módulo, jerarquía base y scope operativo.', path: '/seguridad/roles' },
  { title: 'Auditoría', description: 'Diff amigable por cambio, actor y trazabilidad de seguridad.', path: '/seguridad/auditoria' },
  { title: 'Sesiones', description: 'Seguimiento de sesiones activas y contexto operativo por usuario.', path: '/seguridad/sesiones' },
];

export default function SeguridadHome() {
  const [{ data: usersData }] = useQuery({ query: SECURITY_USERS_QUERY });
  const [{ data: rolesData }] = useQuery({ query: SECURITY_ROLES_QUERY });
  const users = usersData?.security_users || [];
  const roles = rolesData?.security_roles || [];

  return (
    <div className="min-h-screen w-full bg-[rgb(var(--bg))] pb-16">
      <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-8 px-6 pt-10">
        <PageHeader
          title="Seguridad"
          subtitle="Centro operativo de identidad, accesos, jerarquía, sucursales y auditoría de SinamonSoftV3."
        />

        <section className="grid gap-4 md:grid-cols-3">
          <article className="card rounded-2xl p-5">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[rgb(var(--muted))]">Usuarios</p>
            <p className="mt-2 text-3xl font-semibold text-[rgb(var(--fg))]">{users.length}</p>
          </article>
          <article className="card rounded-2xl p-5">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[rgb(var(--muted))]">Bloqueados</p>
            <p className="mt-2 text-3xl font-semibold text-[rgb(var(--fg))]">{users.filter((user) => user.bloqueado).length}</p>
          </article>
          <article className="card rounded-2xl p-5">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[rgb(var(--muted))]">Roles</p>
            <p className="mt-2 text-3xl font-semibold text-[rgb(var(--fg))]">{roles.length}</p>
          </article>
        </section>

        <section className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4">
          {quickLinks.map((item) => (
            <NavLink
              key={item.title}
              to={item.path}
              className="group relative overflow-hidden rounded-2xl border border-[rgba(var(--border),0.45)] bg-[rgba(var(--panel),0.86)] p-6 shadow-[0_16px_40px_rgba(var(--shadow),0.08)] transition-all duration-200 hover:-translate-y-1 hover:border-[rgba(var(--brand),0.3)] hover:shadow-[0_20px_50px_rgba(var(--shadow),0.18)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            >
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(var(--brand),0.08),transparent_65%)] opacity-0 transition-opacity duration-200 group-hover:opacity-100" />
              <div className="relative flex h-full flex-col gap-3">
                <h2 className="text-xl font-semibold tracking-tight text-[rgb(var(--fg))]">{item.title}</h2>
                <p className="flex-1 text-sm leading-relaxed text-[rgba(var(--muted),0.95)]">{item.description}</p>
                <span className="text-sm font-medium text-[rgb(var(--brand))]">Abrir</span>
              </div>
            </NavLink>
          ))}
        </section>
      </div>
    </div>
  );
}
